<main class="bg-grey-100">
    <section class="inner-page-wrapper">
        <div class="mb-12 py-16 md:mb-40">
            <h1 class="text-24 leading-28 text-black md:text-center md:text-50 md:leading-58">
                Aktuelle Hyundai Aktionen
            </h1>

            <h2 class="text-16 leading-27 text-black md:text-center md:text-22 md:leading-28">
                {{ dealerLocationHeadline() }}
            </h2>
        </div>
        <div
            class="mb-[22px] flex gap-40 overflow-x-scroll whitespace-nowrap break-keep md:justify-center md:overflow-x-auto"
            role="tablist"
        >
            <button
                class="border-b-4 pb-4 font-headline text-14 leading-27 text-accent hover:font-medium md:text-18"
                [ngClass]="{
                    'border-b-accent font-medium': filter() === 'all',
                    'border-b-transparent': filter() !== 'all',
                }"
                [attr.aria-selected]="filter() === 'all'"
                (click)="filter.set('all')"
                role="tab"
            >
                Alle Aktionen
            </button>

            @for (category of campaigns().categories; track $index) {
                <button
                    class="border-b-4 pb-4 font-headline text-14 leading-27 text-accent md:text-18"
                    [ngClass]="{
                        'border-b-accent font-medium': filter() === category,
                        'border-b-transparent': filter() !== category,
                    }"
                    [attr.aria-selected]="filter() === category"
                    (click)="filter.set(category)"
                    role="tab"
                >
                    {{ category }}
                </button>
            }
        </div>
        <div class="grid grid-cols-1 gap-y-40 pb-24 md:grid-cols-2 md:gap-[56px] lg:grid-cols-3">
            @for (regularCampaign of filterredCampaigns(); track regularCampaign) {
                <ui-m040-c050-card
                    [headline]="regularCampaign.teaserHeadline"
                    [text]="regularCampaign.teaserCopy ?? undefined"
                    [image]="regularCampaign.heroImage"
                    [link]="regularCampaign.detailUrl"
                    [badge]="regularCampaign.badge"
                    isFirstView
                    hasAspectRatio
                />
            }
        </div>
    </section>
</main>
